import includes from "lodash/includes";

export default (string, search) =>
  string && search ? includes(string.toLowerCase().trim(), search.toLowerCase().trim()) : true;
